import AuthentificationService from '@/services/authentification'
import DownloadJs from 'downloadjs'
export default {
  get: async function(url, body) {
    let headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }

    const response = await doFetch(url, {
      method: 'get',
      headers,
      body: body
    })

    return response
  },
  post: async function(url, body) {
    let headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }

    const response = await doFetch(url, {
      method: 'post',
      headers,
      body: body
    })

    return response
  },
  download: async function(url, filename) {
    let headers = {
      'Content-Type': 'application/json'
    }

    const response = await doFetch(url, {
      method: 'get',
      headers
    })

    const blob = await response.blob();
    DownloadJs(blob, filename);
  }
}

async function doFetch(uri, params) {
  let token = await AuthentificationService.getUserToken()
  const isLogged = token !== '' && token !== null
  if (isLogged) {
    params.headers.authorization = `Bearer ${token}`
  }

  let r1 = await fetch(uri, params)

  if (isLogged && r1.status === 401) {
    let isRenewTokenSuccess = await AuthentificationService.renewToken()

    if (!isRenewTokenSuccess) {
      return r1
    }

    token = await AuthentificationService.getUserToken()
    if (token !== '') {
      params.headers.authorization = `Bearer ${token}`
    }

    let r2 = await fetch(uri, params)

    if (isLogged && r2.status === 401) {
      await AuthentificationService.logout()
      throw new Error('Unauthorized')
    }

    return r2
  }

  return r1
}
